// @flow
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import type {ApplicationState} from "../../reducers";
import {clearSearchPreview, getSearchPreview, setSearchPhrase} from "../../actions/filter";
import {setVehicle} from "../../actions/vehicle";
import {getPopularProducts} from "../../actions/products";
import SearchBar from "../../components/layout/SearchBar";
import history from "../../history";
import {currencyConverter} from "../../helper/currency";
import {setCategorySelectionSource} from "../../helper/tracker/internalEvents";
import type {PreviewCategory, PreviewVehicle} from "../../helper/searchPreview";
import type {Product} from "../../models/Product";

// The tracking contract (trackingSchemas.js, "HPM Events documented") knows no source of its own for
// the search preview yet, so a pick from it is reported as the filter choice it amounts to.
const CATEGORY_SELECTION_SOURCE = "filter";
const VEHICLE_SELECTION_SOURCE = "filter_top";

function mapStateToProps(state: ApplicationState, ownProps) {
	return {
		value: state.filter.searchPhrase,
		preview: state.filter.searchPreview,
		showPrice: !state.config.productPricesDisabled,
		formatPrice: currencyConverter,
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		handleChange: value => dispatch(setSearchPhrase(value)),
		fetchPreview: typed => dispatch(getSearchPreview(typed)),
		clearPreview: () => dispatch(clearSearchPreview()),
		openProduct: (product: Product) => {
			dispatch(setSearchPhrase(""));
			history.pushProduct(product.id, product.name.replace("%", ""));
		},
		openCategory: (category: PreviewCategory) => {
			dispatch(setSearchPhrase(""));
			setCategorySelectionSource(CATEGORY_SELECTION_SOURCE);
			history.pushCategory(category.name || category.key);
		},
		// a vehicle stands for all of its accessories, so it opens the shop under that vehicle
		// rather than the hits of the typed words
		selectVehicle: (vehicle: PreviewVehicle) => {
			dispatch(setSearchPhrase(""));
			dispatch(vehicle.isSeries
				? setVehicle(vehicle.key, null, VEHICLE_SELECTION_SOURCE)
				: setVehicle(null, vehicle.key, VEHICLE_SELECTION_SOURCE));

			const isOnStartPage = history.location.pathname.endsWith("/shop") || history.location.pathname === "/";
			if (isOnStartPage) {
				// the start page loads its products when it mounts, and it is mounted already
				dispatch(getPopularProducts());
			} else {
				history.pushHome();
			}
		},
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SearchBar));
